import { useTranslation } from 'react-i18next';
import { downloadFile } from '../../File/util';
import { ClickMenuItem } from './ClickMenu';
import { Icon } from './Icon';

interface DownloadFileMenuItemOptionProps {
  disabled?: boolean;
  fileName: string;
  downloadURL: string;
}

export function DownloadFileMenuItemOption({ disabled, downloadURL, fileName }: DownloadFileMenuItemOptionProps) {
  const { t: tFile } = useTranslation('file');

  return (
    <ClickMenuItem disabled={disabled} hideOnClick onClick={() => downloadFile(fileName, downloadURL)}>
      <span className="text-lg font-medium text-white">{tFile('download-file-label')}</span>
      <Icon icon="download" className="text-palette-600" />
    </ClickMenuItem>
  );
}
